// utils/formatDate.ts

/**
 * Format a date string into "18 Sep 2025, 08:28"
 * Works with ISO strings like "2025-09-18 08:28:16".
 */
export function formatDate(dateStr?: string | null): string {
  if (!dateStr) return "N/A"

  try {
    const date = new Date(dateStr)

    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(date)
  } catch {
    return "Invalid date"
  }
}
